// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__26hNI","signatureBlock":"Footer_signatureBlock__TdZta","signature":"Footer_signature__1RfC_"};